import AlarmsCard from "./AlarmsCard"

export default  AlarmsCard;
